import Image from "next/image";
import Link from "next/link";
import styled from "styled-components";

const StyledSocials = styled.div`
display:flex;
gap:16px;
`
const Social = () => {
    return (
        <StyledSocials>
            <Link
                href="https://www.instagram.com/politicamenteinformados/"
                target="_blank"
                rel="noreferrer">
                <Image
                    src="/assets/socials/instagram.svg"
                    width={24}
                    height={24}
                    alt="Visita o nosso Instagram"
                />
            </Link>
            <Link
                href="https://www.facebook.com/politicamenteinformados.pt"
                target="_blank"
                rel="noreferrer">
                <Image
                    src="/assets/socials/facebook.svg"
                    width={24}
                    height={24}
                    alt="Visita o nosso Facebook"
                />
            </Link>
            <Link
                href="https://www.youtube.com/@politicamenteinformados1352"
                target="_blank"
                rel="noreferrer">
                <Image
                    src="/assets/socials/youtube.svg"
                    width={24}
                    height={24}
                    alt="Visita o nosso Youtube"
                />
            </Link>
            {/* <Link
                href="https://twitter.com/polinformados"
                target="_blank"
                rel="noreferrer">
                <Image
                    src="/assets/socials/twitter.svg"
                    width={24}
                    height={24}
                    alt="Visita o nosso Twitter"
                />
            </Link> */}
        </ StyledSocials>
    );
};

export default Social;
